import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-form-submit-button',
  templateUrl: './form-submit-button.component.html',
  styleUrls: ['./form-submit-button.component.scss']
})
export class FormSubmitButtonComponent implements OnInit {

  @Input()
  hideArrow: boolean;

  constructor() { }

  ngOnInit() {
  }

}
